import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';
import NavigationHistory from '@Services/NavigationHistory';

export const notificationMessage = 'To access Alert content, please sign in or register.';

function _checkLastVisitedState(lastVisitedState) {
  return (
    // hopinto new alerts
    (getValueByNs(lastVisitedState, 'name') === 'main.hopinto' && getValueByNs(lastVisitedState, 'params.origin') === 'email-doc') ||
    // new alerts page
    getValueByNs(lastVisitedState, 'name') === 'main.alerts.new'
  );
}

/*
 * Must return new updated object:
 * {
 *   CUSTOM_LEFT: [...],
 *   CUSTOM_RIGHT: [...],
 * }
 * CUSTOM_LEFT and CUSTOM_RIGHT should be concatted with the already existing notifications!
 * */
export function alertsNotificationsGetter() {
  return (notifications) => {
    const { CUSTOM_LEFT = [], CUSTOM_RIGHT = [] } = notifications;
    const lastVisitedState = NavigationHistory.getLastVisitedStateForLogin();
    const shouldDisplayNotification = _checkLastVisitedState(lastVisitedState);

    return {
      ...notifications,
      CUSTOM_LEFT: shouldDisplayNotification ? CUSTOM_LEFT.concat([notificationMessage]) : CUSTOM_LEFT,
      CUSTOM_RIGHT,
    };
  };
}
